import { Component, Input, OnInit } from '@angular/core'
import { BoxFormatModel, BoxPatternEnum } from '../../../models/box-format.model';
import { TranslateService } from '@ngx-translate/core'

@Component({
  selector: 'flowaccount-box-format',
  templateUrl: './box-format.component.html',
  styleUrls: ['./box-format.component.scss'],
})
export class BoxFormatComponent {
  @Input() boxList

  // boxList: BoxFormatModel = {
  //   boxPattern: BoxPatternEnum.textLeftImageRight,
  //   boxClassName: '',

  //   boxTopHeading: '',
  //   boxTopHeading_tablet: '',
  //   boxTopHeading_mobile: '',
  //   boxTopSubHeading: '',
  //   boxTopHeadingDetail: '',

  //   boxHeading: '',
  //   boxHeading_tablet: '',
  //   boxHeading_mobile: '',
  //   boxSubHeading: '',
  //   boxHeadingDetail: '',

  //   boxImageWebP: '',
  //   boxImage: '',
  //   boxImageType: '',
  //   boxImageAlt: '',
  // }

  textLeftImageRight = BoxPatternEnum.textLeftImageRight
  textRightImageLeft = BoxPatternEnum.textRightImageLeft

  constructor(public translate: TranslateService) {}

  ngOnInit(): void {}
}
